<script>
    /*
    	SortButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    const SVG_OPENED_PATH = '/img/chevron_right_purple.png';
    const SVG_CLOSED_PATH = '/img/chevron_left_purple.png';

    export let onClick;
    export let isSelected;

    onMount(() => {
    })

</script>

<style>

    /* TODO: use a SMUI Button here? */
    .sort-button button {
        width: 100px;
        padding: 8px 20px;
        font-size: 14px;
        color: var(--tcui-primary);
        background: none;
        border-radius: 16px;
        border: 1px solid #F8F3F8;
        border-radius: 35px;    
    }

    .sort-button.selected button {
        background-color: #DFCDD8;
    }

    /*
    .sort-button button:hover {
        background-color: var(--tcui-ruby-light);
    }
    */
    
    .sort-button .button-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sort-button .button-content img {
        /* width: 13px; */
        /* height: 13px; */
        margin-left: 10px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- TODO: use open/closed icon -->
{#if isSelected}
    <div class="sort-button selected">
        <button on:click={onClick}>
            <div class="button-content">
                Sort
                <img src={SVG_OPENED_PATH} alt={'Chevron right'} draggable="false" >
            </div>
        </button>
    </div>
{:else}
    <div class="sort-button">
        <button on:click={onClick}>
            <div class="button-content">
                Sort
                <img src={SVG_CLOSED_PATH} alt={'Chevron left'} draggable="false" >
            </div>
        </button>
    </div>
{/if}

